<template>
  <div class="w-full rounded-md border border-gray-200 p-6">
    <div class="flex flex-col items-center text-center">
      <!-- Logo (uses header logo by default; parent can override via slot) -->
      <div class="mb-6">
        <slot name="logo">
          <img src="@/_assets/img/header.svg" alt="Epasnets" class="h-24" />
        </slot>
      </div>

      <h2 class="text-2xl md:text-3xl font-display font-bold text-rose-400 mb-4">Danke für euer Vertrauen!</h2>

      <div class="text-left w-full text-gray-800 leading-relaxed">
        <p class="mb-4">
          Unser Gutschein-Marktplatz, der in der Corona-Zeit entstanden ist, hat gezeigt, wie stark regionale
          Gemeinschaft sein kann –
          <span class="font-semibold">tausende Gutscheine wurden gekauft und verschenkt</span>.
        </p>
        <p class="mb-6">
          Leider müssen wir den Dienst nun einstellen, da unser Zahlungsdienstleister neue Anforderungen stellt, die
          einen kompletten Umbau der Plattform erfordern würden – ein Schritt, der für unser regionales Projekt nicht
          finanzierbar ist.
        </p>

        <p class="mb-2 font-semibold">👉 Das bedeutet das Ganze für euch:</p>
        <ul class="list-disc ml-5 mb-6">
          <li>Neue Gutscheinverkäufe sind nicht mehr möglich.</li>
          <li>Bereits gekaufte Gutscheine können weiterhin eingelöst und bearbeitet werden.</li>
          <li>Regions- und Teamgutscheine bleiben aktiv.</li>
        </ul>

        <p class="mb-6 text-lg">
          Von Herzen vielen Dank für eure Unterstützung und die gemeinsame Reise!
          <span class="ml-1" aria-hidden="true">💚</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EpasnetsNotice",
};
</script>

<style scoped></style>
